import { render } from "./B2bTagsComponent.vue?vue&type=template&id=1b822054&scoped=true&lang=pug"
import script from "./B2bTagsComponent.vue?vue&type=script&lang=js"
export * from "./B2bTagsComponent.vue?vue&type=script&lang=js"

import "./B2bTagsComponent.vue?vue&type=style&index=0&id=1b822054&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b822054"]])

export default __exports__